import { render, staticRenderFns } from "./Topup.vue?vue&type=template&id=f82fbd90&scoped=true"
import script from "./Topup.vue?vue&type=script&lang=js"
export * from "./Topup.vue?vue&type=script&lang=js"
import style0 from "./Topup.vue?vue&type=style&index=0&id=f82fbd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82fbd90",
  null
  
)

export default component.exports